module.exports = __webpack_public_path__ + "img/car-3.69bdefb0.png";